import styled from 'styled-components'

import * as colors from '../constants/colors'
import * as effects from '../constants/neue/effects'
import * as fonts from '../constants/fonts'
import * as headings from './heading'

export const Wrapper = styled.a`
  border: 1px solid ${colors.GREY_SHADE_5};
  box-sizing: border-box;
  color: black;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-width: 300px;
  min-height: 308px;
  min-width: 230px;
  position: relative;
  text-decoration: none;

  &:hover {
    transition: all 200ms ease-in-out;
    box-shadow: ${effects.SHADOW_4};
  }
`

export const Content = styled.div`
  border-top: none;
  padding: 15px 15px 35px;
  position: relative;
`

export const Title = styled(headings.XXS)`
  color: ${(props) => props.color};
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
  text-align: center;
  margin: 0;
`

export const Infos = styled.div<{ color?: string }>`
  background-color: ${({ color }) => color};
  border-radius: 1px;
  bottom: -5px;
  color: ${colors.PRIMARY_WHITE};
  font-family: ${fonts.PRIMARY_FONT};
  left: 50%;
  padding: 4px 14px;
  position: absolute;
  transform: translateX(-50%);

  span {
    font-size: 12px;
    font-weight: bold;
    line-height: 18px;
  }

  svg {
    height: 12px;
    margin-top: -1px;
    margin-right: 5px;
  }
`

export const Description = styled.p`
  font-family: ${fonts.PRIMARY_FONT};
  font-size: 15px;
  font-weight: 300;
  height: 100%;
  line-height: 20px;
  overflow: hidden;
  text-align: center;
  width: 100%;
`

export const Icon = styled.div<{ color?: string }>`
  align-items: center;
  background-color: ${({ color }) => color};
  display: flex;
  height: 165px;
  justify-content: center;

  img {
    width: 130px;
    height: 130px;
  }
`
